<template>
  <a v-if="sms" :href="'sms:' + standardPhoneNumber" data-test-call-to-sms>
    <span class="adn-icon adn-icon--function-message" aria-hidden="true" />
    <span>SMS</span>
  </a>
  <a v-else :href="'tel:' + standardPhoneNumber" data-test-call-to-phone>
    <span class="adn-icon adn-icon--function-phonecall" aria-hidden="true" />
    <span>Appeler</span>
  </a>
</template>

<script lang="ts">
export default {
  name: 'AdnCallToPhone',
  props: {
    phoneNumber: {
      type: String,
      required: true,
    },
    sms: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    standardPhoneNumber() {
      if (/^\d{9}$/.test(this.phoneNumber)) {
        return `0${this.phoneNumber}`
      }
      return this.phoneNumber
    },
  },
}
</script>

<style lang="scss" scoped>
a {
  display: flex;
  align-items: center;
  flex-direction: column;

  .adn-icon {
    $icon-radius: 4rem;

    background-color: var(--color-main-background);
    border-radius: 25px;
    height: $icon-radius;
    width: $icon-radius;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
